import React from 'react';
import {
  createLaunchDarklyContext,
  useCurrentAccountId,
  useCurrentProjectId,
} from '@adsk/alloy-provider';
import { getEnv, ENVS } from '@adsk/acs-sc-web-platform-api';

export const AdminLDContext = React.createContext(undefined);

const {
  LaunchDarklyProvider: PlangridLaunchDarklyProvider,
  useFeatureFlag: usePlangridFeatureFlag,
} = createLaunchDarklyContext(AdminLDContext);

const clientSideIdByEnv = {
  [ENVS.QA]: '5cfe5a82648b9507525dcb0e',
  [ENVS.STAGING]: '5d12565bd7bc9707683c5682',
  [ENVS.PRODUCTION]: '5cfe5a817682e907558f568c',
};

/**
 * This HOC exposes Admin related feature flags to its consumers
 */
export const withPlangridFFs = (WrappedComponent) => {
  const env = getEnv();

  const WrappedComponentWithFFs = (props) => {
    const projectId = useCurrentProjectId();
    const accountId = useCurrentAccountId();

    return (
        <PlangridLaunchDarklyProvider
            apiKey={clientSideIdByEnv[env]}
            projectEntitlementsUnavailable={!projectId && !accountId}
        >
          <WrappedComponent {...props} />
        </PlangridLaunchDarklyProvider>
    );
  };
  WrappedComponentWithFFs.propTypes = WrappedComponent.propTypes;

  return WrappedComponentWithFFs;
};

export { usePlangridFeatureFlag };
